import { type ServerMessage } from '@soulhx/fs-common';
import i18n from '../../../../../i18n.js';

interface ResourceBundle {
  lang: string;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  resources: any;
}

export const parseServerMessagesForI18n = (messages: ServerMessage[], searchString?: string) => {
  const bundles: ResourceBundle[] = [];

  for (const message of messages) {
    for (const txt of message.text) {
      if (searchString && !txt.msg.includes(searchString)) {
        continue;
      }

      const index = bundles.findIndex((b) => b.lang === txt.lang);
      if (index >= 0) {
        bundles[index].resources[message.id] = txt.msg;
      } else {
        bundles.push({ lang: txt.lang, resources: { [message.id]: txt.msg } });
      }
    }
  }

  for (const b of bundles) {
    i18n.addResourceBundle(b.lang, 'serverMessages', b.resources);
  }
};
